import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Indicator } from '@uhg-abyss/web/ui/Indicator';
import { isEmpty } from 'lodash';
import React from 'react';

import { Details } from './components/Details';
import { RecommendationResponses } from './components/RecommendationResponses';
import { Styles } from './includes/styles';

/**
 * Widget: ActionPaths
 *
 * Displays affiliated action paths with the risk record.
 *
 * @param handleSearch
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function ActionPaths({ handleSearch = () => {}, riskRecord = {} }) {
  const actionPaths = riskRecord?.recordActionPaths;
  const eid = riskRecord?.eid;

  return (
    <ErrorHandler location="src/widgets/RiskRecords/ActionPaths/ActionPaths.jsx">
      <Styles>
        {isEmpty(actionPaths) ? (
          <Alert title="There are no actions paths for this risk record." variant="info" />
        ) : (
          <Accordion isCollapsible type="multiple">
            {actionPaths.map((actionPath) => {
              return (
                <Accordion.Item key={`${actionPath?.name}`} value={actionPath?.name}>
                  <Accordion.Trigger>
                    <Accordion.Header>
                      {actionPath?.manualAssociation === true ? (
                        <div style={{ width: 'auto' }}>
                          <Indicator color="var(--abyss-colors-warning1)" label="M" showZero={false} withBorder>
                            <div style={{ marginRight: 'var(--abyss-space-sm)' }}> {actionPath?.name}</div>
                          </Indicator>
                        </div>
                      ) : (
                        actionPath?.name
                      )}
                    </Accordion.Header>
                  </Accordion.Trigger>
                  <Accordion.Content>
                    <Details actionPath={actionPath} eid={eid} handleSearch={handleSearch} />
                    <RecommendationResponses actionPath={actionPath} />
                  </Accordion.Content>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </Styles>
    </ErrorHandler>
  );
}
